import {
  GET_LANDING_NFTS_REQUEST,
  GET_LANDING_NFTS_SUCCESS,
  GET_LANDING_NFTS_FAILURE,
  GET_NFT_MINTED_REQUEST,
  GET_NFT_MINTED_SUCCESS,
  GET_NFT_MINTED_FAILURE,
  GET_NFT_OWNERS_REQUEST,
  GET_NFT_OWNERS_SUCCESS,
  GET_NFT_OWNERS_FAILURE,
  GET_OWNED_LANDING_NFTS_REQUEST,
  GET_OWNED_LANDING_NFTS_SUCCESS,
  GET_OWNED_LANDING_NFTS_FAILURE,
} from 'redux/actionTypes/nftActionTypes';

const INITIAL_STATE = {
  gettingLandingNfts: false,
  gettingLandingNftsError: '',
  landingNfts: [],

  nftMintedState: {},

  gettingNftOwners: false,
  gettingNftOwnersError: '',
  nftOwners: '',

  gettingOwnedLandingNfts: false,
  gettingOwnedLandingNftsError: '',
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_LANDING_NFTS_REQUEST:
      return {
        ...state,
        gettingLandingNfts: true,
        gettingLandingNftsError: '',
      };

    case GET_LANDING_NFTS_SUCCESS:
      return {
        ...state,
        gettingLandingNfts: false,
        gettingLandingNftsError: '',
        landingNfts: payload,
      };

    case GET_LANDING_NFTS_FAILURE:
      return {
        ...state,
        gettingLandingNfts: false,
        gettingLandingNftsError: payload,
      };

    case GET_OWNED_LANDING_NFTS_REQUEST:
      return {
        ...state,
        gettingOwnedLandingNfts: true,
        gettingOwnedLandingNftsError: '',
      };

    case GET_OWNED_LANDING_NFTS_SUCCESS:
      return {
        ...state,
        landingNfts: payload,
      };

    case GET_OWNED_LANDING_NFTS_FAILURE:
      return {
        ...state,
        gettingOwnedLandingNfts: false,
        gettingOwnedLandingNftsError: payload,
      };

    case GET_NFT_OWNERS_REQUEST:
      return {
        ...state,
        gettingNftOwners: true,
        gettingNftOwnersError: '',
      };

    case GET_NFT_OWNERS_SUCCESS:
      return {
        ...state,
        gettingNftOwners: false,
        gettingNftOwnersError: '',
        nftOwners: payload,
      };

    case GET_NFT_OWNERS_FAILURE:
      return {
        ...state,
        gettingNftOwners: false,
        gettingNftOwnersError: payload,
      };

    case GET_NFT_MINTED_REQUEST:
      return {
        ...state,
        nftMintedState: {
          ...state.nftMintedState,
          [action.id]: {
            ...state.nftMintedState[action.id],
            gettingMinted: true,
            gettingMintedError: '',
          },
        },
      };

    case GET_NFT_MINTED_SUCCESS:
      return {
        ...state,
        nftMintedState: {
          ...state.nftMintedState,
          [action.id]: {
            ...state.nftMintedState[action.id],
            gettingMinted: false,
            gettingMintedError: '',
            minted: payload,
          },
        },
      };

    case GET_NFT_MINTED_FAILURE:
      return {
        ...state,
        nftMintedState: {
          ...state.nftMintedState,
          [action.id]: {
            ...state.nftMintedState[action.id],
            gettingMinted: false,
            gettingMintedError: payload,
          },
        },
      };

    default:
      return state;
  }
};
